import Component from './Accordion.vue';

export default {
  install(Vue) {
    Vue.component('BkfAccordion', Component);
  },
};
